
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { useMobileMenu } from "@/components/dashboard/header/useMobileMenu";
import { useLanguagePath } from "@/utils/language";
import { useTranslations } from "@/hooks/useTranslations";

export const WorkoutHeader = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { closeMenu } = useMobileMenu();
  const { getPath } = useLanguagePath();
  const { t } = useTranslations("workouts");
  
  const handleNavigate = () => {
    closeMenu();
    navigate(getPath("/dashboard/workouts/new"));
  };
  
  return (
    <Button 
      onClick={handleNavigate} 
      className="bg-flame text-white hover:bg-flame/90 rounded-xl shadow-md hover:shadow-lg transition-all flex items-center gap-2"
    >
      <Plus className="h-4 w-4" />
      {t("actions.newWorkout")}
    </Button>
  );
};
